export default "__VITE_ASSET__W$fX2nq3__"